export default __webpack_public_path__ + "static/header-ensino-fundamental-i-2a43cf7e46e65e1a63698a0544303f88.png";